import type { SensitiveDataSession } from "./sensitive-data-session";
import { saveSecureFile, NO_PASSPHRASE_KEY } from "./secure-file-save";
import { saveHandle } from "./secure-file-handle-store";

/**
 * s227 (LOGOUT-SAVE-CHECK-1) — write the session's Cat A values to the Secure File and mark them saved. ONE save
 * flow for the amber banner (`SecureFileBanner`) and the sign-out check (`LogoutSaveCheck`), lifted out of the
 * banner unchanged so the two can never save differently.
 *
 * Silent write to the existing handle on Chrome/Edge; native picker or a download otherwise. Throws on failure; a
 * user-cancelled picker throws `AbortError` (the caller treats that as a no-op, not a failure).
 */
export async function saveSessionSecureFile(session: SensitiveDataSession): Promise<void> {
  const values = session.getAllValues();
  const { handle } = await saveSecureFile({
    values,
    passphrase: session.passphrase,
    handle: session.fileHandle,
  });
  // First save (no prior handle) on Chrome/Edge → record the handle so future saves
  // are silent, and the passphrase so they don't re-prompt.
  if (handle && !session.fileHandle) {
    session.completeSetup(handle, session.passphrase ?? NO_PASSPHRASE_KEY);
  }
  if (handle) void saveHandle(handle); // persist for Phase 3 auto-reconnect
  session.markSaved(Object.keys(values));
}
